import styled from "styled-components";

export default styled.div`
  align-items: center;
  display: none;
  text-align: center;
  margin: 30px;
  width: 70vw;
  height: 60vh;

  @media only screen and (max-width: 1024px) {
    display: flex;
  }
`;
